export default {
  "menu.SelfAuditSettingListPage": "安全自检",
}